import React, { useContext, useEffect } from 'react';

import RegistrationFormRow from './RegistrationFormRow'
import RegistrationFormSection from './RegistrationFormSection';
import { useTranslation, Trans } from 'react-i18next';
import RegistrationFormCountry from './RegistrationFormCountry';
import EventContext from '../contexts/EventContext';

const RegistrationFormContactAndOrganismeSection = ({ contact }) => {

    const { t, i18n } = useTranslation();

    const eventContext = useContext(EventContext);

    const { currentEvent } = eventContext;

    useEffect(() => {

    }, [i18n.resolvedLanguage, contact])

    return <RegistrationFormSection title={t('form.sections.contact_and_organisation_section.section_title')}>

        <> <RegistrationFormRow
            name='prenom'
            placeholder={t('form.sections.contact_section.prenom')}
            defaultValue={contact?.prenom} />

            <RegistrationFormRow
                name='nom'
                placeholder={t('form.sections.contact_section.nom')}
                defaultValue={contact?.nom} />

            <RegistrationFormRow
                name='fonction'
                placeholder={t('form.sections.contact_section.fonction')}
                defaultValue={contact?.fonction}
            />

            <RegistrationFormRow
                name='port'
                placeholder="Mobile"
                defaultValue={contact?.port}
            />
        </>


        <RegistrationFormRow
            name='mail'
            placeholder="E-mail"
            defaultValue={contact?.mail} />

        <RegistrationFormRow
            name='societe'
            placeholder={t('form.sections.organisme_section.societe')}
            defaultValue={contact?.societe} />
        {/* 
        <RegistrationFormRow
            isRegister
            inputType="textarea"
            name='edito_long'
            placeholder={t('form.sections.organisme_section.edito_long')}
            required={false}
            defaultValue={contact?.edito_long} />

             
        */}
        <RegistrationFormCountry required={true} />

        <RegistrationFormRow
            inputType="file"
            name='photo'
            placeholder={t('form.sections.contact_section.photo')}
            defaultValue={contact?.photos.large}
            required={contact?.photos.large != '' ? false : true}
            accept={['.jpeg', '.png', '.jpg']}
            helper="Important  : Cette photo sera restituée lors de l'enregistrement de votre webcast" />

        <RegistrationFormRow
            inputType="file"
            name='logo'
            placeholder={t('form.sections.organisme_section.logo')}
            defaultValue={contact?.logos.large}
            required={contact?.logos.large != '' ? false : true}
            accept={['.jpeg', '.png', '.jpg']} />

        <RegistrationFormRow
            required={false}
            inputType="text"
            name='web'
            placeholder="Site web"
            defaultValue={contact?.web}
            helper="Lien de votre site web qui sera présenté en conclusion  lors du webcast" />

        <hr className='mb-3' />
        <h4 className="row pl-5  pb-3 text-2xl font-bold">
            {t('form.sections.contact_and_organisation_section.video_section_title')}
        </h4>

        <div className="row pl-5 pb-3 bg-cyan-100 m-1 p-3 rounded">
            <p>Collez ci dessous le lien d'une de vos videos (option 1) ou uploadez en une (Option 2).</p>
            <p>Si vous n'avez pas de video nous vous incitons à créer vous même un petit diaporama  à partir de photo qui illustrent votre savoir faire, vos clients ou votre solution que vous pourrez commenter lors du webcast.</p>
            <p>Si vous n'avez pas de photo mettez le lien de votre vite web qui sera présenté à la place de votre video.
            </p> </div>
        <RegistrationFormRow
            required={false}
            textLabel="Option 1"
            inputType="text"
            name='organisme_video_url'
            placeholder=""
            helper={t('form.sections.contact_and_organisation_section.video_url_helper')}
            defaultValue={contact?.organisme_video_url} />

        <RegistrationFormRow
            required={false}
            inputType="file"
            name='organisme_video_hosted'
            placeholder="Option 2"
            helper=""
            accept={[
                //video format

                ".mp4",
                ".avi",
                ".mov",
                ".flv",
                ".wmv",
                ".webm",
                ".mkv",


            ]} />


    </RegistrationFormSection>
}

export default RegistrationFormContactAndOrganismeSection;
